import axios from "../../axios";

export const getLevels = async(group, accessType) => {
   
   const {data} = await axios.get(`levels/${group}/${accessType}`)
  
   return data
}